import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { BadgeCheck, MapPin, Star, ArrowRight } from "lucide-react";
import { inr } from "@/lib/api";

export function MkCard({ item, kind }) {
    const nav = useNavigate();
    const to = `/${kind}/${item.slug}`;
    const fee = item.fee != null ? (item.fee === 0 ? "Free" : `From ${inr(item.fee)}`) : null;
    const subtitle = {
        opportunities: item.organiser, experts: item.title, influencers: item.category,
        podcasts: `Hosted by ${item.host}`, events: item.organiser, brands: item.industry,
    }[kind];
    const metaLine = {
        opportunities: `${item.location} · ${item.date}`, experts: `${item.experience} · ${item.location}`,
        influencers: `${item.followers} followers · ${item.engagement} eng.`, podcasts: `${item.audience} · ${item.episodes} eps`,
        events: `${item.date} · ${item.location}`, brands: item.location,
    }[kind];
    const heading = ["opportunities", "events"].includes(kind) ? (item.title || item.name) : (item.name || item.title);
    return (
        <motion.button onClick={() => nav(to)} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.35 }}
            className="card-teal rounded-2xl overflow-hidden text-left group flex flex-col" data-testid={`mk-card-${item.slug}`}>
            <div className="h-44 overflow-hidden relative">
                <img src={item.image} alt={item.title || item.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                {item.category && <span className="absolute top-3 left-3 bg-teal-950/80 text-gold text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wide">{item.category}</span>}
                {item.featured && <span className="absolute top-3 right-3 bg-gold text-teal-900 text-[10px] font-bold px-2.5 py-1 rounded-full">Featured</span>}
            </div>
            <div className="p-5 flex-1 flex flex-col">
                <div className="flex items-start gap-1.5">
                    <h3 className="font-bold text-cream leading-snug flex-1">{heading}</h3>
                    {item.verified && <BadgeCheck className="w-4 h-4 text-growth shrink-0 mt-0.5" />}
                </div>
                {subtitle && <p className="text-sm text-cream-soft/80 mt-1">{subtitle}</p>}
                {item.rating && <div className="flex items-center gap-1 mt-2 text-xs text-gold"><Star className="w-3.5 h-3.5 fill-gold" /> {item.rating} ({item.reviews})</div>}
                <div className="flex items-center gap-1 text-xs text-cream-soft/60 mt-2"><MapPin className="w-3.5 h-3.5" /> {metaLine}</div>
                <div className="mt-auto pt-4 flex items-center justify-between">
                    {fee && <span className="font-mono font-bold text-cream text-sm">{fee}</span>}
                    <span className="inline-flex items-center gap-1 text-sm font-semibold text-gold group-hover:gap-2 transition-all ml-auto">View <ArrowRight className="w-4 h-4" /></span>
                </div>
            </div>
        </motion.button>
    );
}
